export default __webpack_public_path__ + "static/media/yalla-logo.984eae00.png";